module.exports = __webpack_public_path__ + "images/background-iframe.a87972.jpg";